var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "md-field",
    {
      staticClass: "select",
      class: { "md-invalid": _vm.errors.length },
      attrs: { "md-clearable": _vm.clearable }
    },
    [
      _vm.label
        ? _c("label", [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "md-select",
        _vm._b(
          {
            attrs: {
              value: _vm.value,
              placeholder: _vm.placeholder,
              disabled: _vm.disabled
            },
            on: { "md-opened": _vm.onShowOptions, input: _vm.onChange }
          },
          "md-select",
          _vm.selectInputProps,
          false
        ),
        [
          _vm._l(_vm.options, function(option) {
            return _c(
              "md-option",
              {
                key: option[_vm.valueKey],
                attrs: { value: option[_vm.valueKey] }
              },
              [_vm._v("\n      " + _vm._s(option[_vm.labelKey]) + "\n    ")]
            )
          }),
          _vm._v(" "),
          _vm._t("default")
        ],
        2
      ),
      _vm._v(" "),
      _vm._l(_vm.errors, function(error, index) {
        return _c("span", { key: index, staticClass: "md-error" }, [
          _vm._v("\n    " + _vm._s(_vm.$t(`errors.${error}`)) + "\n  ")
        ])
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }